import { CheckSuccess } from '@synergy/components-next';
import { ReactElement, useEffect } from 'react';
import { SHOP_URL } from '@synergy/config';
import { useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

const redirectSupplier = process.env['NX_PUBLIC_APP_SUPPLIER_REDIRECT_URL'] ?? '/';
const redirectCustomer = SHOP_URL;

const enum UserType {
    Customer = 'customer',
    Supplier = 'supplier',
}

export const ConfirmUserSuccess = (): ReactElement => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const userType = useParams()['userType'] as UserType;

    useEffect(() => {
        const timer = setTimeout(redirect, 3000);
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const redirect = () => {
        searchParams.delete('token');
        switch (userType) {
            case UserType.Supplier:
                searchParams.set('redirect_url', redirectSupplier);
                break;
            default:
                searchParams.set('redirect_url', redirectCustomer);
                break;
        }
        navigate({ pathname: '/login', search: searchParams.toString() });
    };

    return <CheckSuccess />;
};
